import { ScreenSize } from 'ha/modules/UI/constants';
import { ListingKind } from '@ha/api/v2/types/Listing';
import { ImgixSize } from 'ha/modules/Image/constants';

export const STATE_NAME = 'listing';

export const galleryOpenedEventName = 'Full screen gallery opened';

export const ACTION_PREFIX = 'LISTING_PAGE';

export const Actions = {
  INITIALIZE: `${ACTION_PREFIX}/INITIALIZE`,
  SET_QUERY_PARAMS: `${ACTION_PREFIX}/SET_QUERY_PARAMS`,
  INITIALIZE_INSTANT_BOOKING: `${ACTION_PREFIX}/INITIALIZE_INSTANT_BOOKING`,
  INSTANT_BOOKING_CHECK: `${ACTION_PREFIX}/INSTANT_BOOKING_CHECK`,

  LOAD_LISTING_START: `${ACTION_PREFIX}/LOAD_LISTING_START`,
  LOAD_LISTING_DONE: `${ACTION_PREFIX}/LOAD_LISTING_DONE`,
  LOAD_LISTING_FAIL: `${ACTION_PREFIX}/LOAD_LISTING_FAIL`,

  LOAD_CITY_START: `${ACTION_PREFIX}/LOAD_CITY_START`,
  LOAD_CITY_DONE: `${ACTION_PREFIX}/LOAD_CITY_DONE`,

  DETECT_DESCRIPTION_LANGUAGE_START: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_START`,
  DETECT_DESCRIPTION_LANGUAGE_DONE: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_DONE`,
  DETECT_DESCRIPTION_LANGUAGE_FAIL: `${ACTION_PREFIX}/DETECT_DESCRIPTION_LANGUAGE_FAIL`,

  TRANSLATE_DESCRIPTION_START: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_START`,
  TRANSLATE_DESCRIPTION_DONE: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_DONE`,
  TRANSLATE_DESCRIPTION_FAIL: `${ACTION_PREFIX}/TRANSLATE_DESCRIPTION_FAIL`,

  TOGGLE_DESCRIPTION_LANGUAGE: `${ACTION_PREFIX}/TOGGLE_DESCRIPTION_LANGUAGE`,

  LOAD_SIMILAR_LISTINGS_START: `${ACTION_PREFIX}/LOAD_SIMILAR_LISTINGS_START`,
  LOAD_SIMILAR_LISTINGS_DONE: `${ACTION_PREFIX}/LOAD_SIMILAR_LISTINGS_DONE`,

  TOGGLE_FULLSCREEN_MAP: `${ACTION_PREFIX}/TOGGLE_FULLSCREEN_MAP`,

  LOAD_TENANT_REVIEWS_OVERALL_START: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_START`,
  LOAD_TENANT_REVIEWS_OVERALL_DONE: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_DONE`,
  LOAD_TENANT_REVIEWS_OVERALL_FAIL: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_OVERALL_FAIL`,

  LOAD_TENANT_REVIEWS_REPORTS_START: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_START`,
  LOAD_TENANT_REVIEWS_REPORTS_DONE: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_DONE`,
  LOAD_TENANT_REVIEWS_REPORTS_FAIL: `${ACTION_PREFIX}/LOAD_TENANT_REVIEWS_REPORTS_FAIL`,
};

export const LISTING_NOT_FOUND_ERROR_MESSAGE = 'Listing with that id not found';

export const INITIAL_MAP_ZOOM = 14;

export const GalleryImgixSizeByScreenSize = {
  [ScreenSize.XS]: ImgixSize.fullscreenMobileLarge,
  [ScreenSize.SM]: ImgixSize.fullscreenMobileLarge,
  [ScreenSize.MD]: ImgixSize.fullscreenDesktopSmall,
  [ScreenSize.LG]: ImgixSize.fullscreenDesktopMedium,
  [ScreenSize.XL]: ImgixSize.fullscreenDesktopLarge,
};

export const GridImgixSizeByScreenSize = {
  [ScreenSize.XS]: ImgixSize.xsmall,
  [ScreenSize.SM]: ImgixSize.small,
  [ScreenSize.MD]: ImgixSize.medium,
  [ScreenSize.LG]: ImgixSize.large,
  [ScreenSize.XL]: ImgixSize.large,
};

export const PageNameByKind: Record<ListingKind, string> = {
  [ListingKind.EntirePlace]: 'Entire place',
  [ListingKind.PrivateRoom]: 'Private room',
  [ListingKind.SharedRoom]: 'Shared room',
};

export const SIMILAR_LISTING_CONFIG = {
  countryCodes: ['pt', 'es', 'it'],
};
